import { useState } from "react";
import ReactPlayer from "react-player";
import MessageActions from "../../MessageActions";
import './index.css';
import markdownIt from 'markdown-it';
import mila from "markdown-it-link-attributes";
import ParentChatMessage from "../../ParentChatMessage";
import { adjustHexColor } from "../../../services/shared";
import { useSelector } from "react-redux";

let md = markdownIt({ html: false, linkify: true, typographer: true, breaks: false });
md.use(mila, { attrs: { target: "_blank", rel: "noopener", } });

export const Video = (props: any) => {
    const { message, topMargin } = props;
    const [isHover, setIsHover] = useState(false);
    const design = useSelector((state: any) => state?.design);

    return (
        <>

            <div className={`ele-video image-container relative rounded-xl py-2 px-4 pb-4 max-w-80 bg-primaryBgColor ${topMargin} v-border ${message.position === 'right' && 'bg-primaryColor'}`}
                onMouseEnter={() => { setIsHover(true) }} onMouseLeave={() => { setIsHover(false) }}>
                {(message?._parent ?
                    <ParentChatMessage
                        backgroundColor={message.position === 'right' ? adjustHexColor(design.themeColor, 10) : '#EBEDED' }
                        parentMessage={message?._parent} messagePosition={message.position}
                    />
                    : null
                )}
                {

                    (message.medias && message.medias.length)
                        ?
                        message.medias.map((media: any) => {
                            return (
                                <>
                                    <div key={media.url + message.mid}>
                                        <ReactPlayer
                                            url={media.url}
                                            controls={true}
                                            playing={false}
                                            width={'auto'}
                                            config={{
                                                youtube: {
                                                    playerVars: {
                                                        origin: window.location.origin
                                                    }
                                                }
                                            }}
                                            style={{ borderRadius: '10px' }}
                                        />
                                        <MessageActions message={message} show={isHover} />
                                    </div>
                                </>

                            )
                        })
                        :
                        <>
                            <p className="mb-2 ele-video-message-label prose" dangerouslySetInnerHTML={{ __html: md.render(message.label) }} />
                            <ReactPlayer
                                url={message.source}
                                controls={true}
                                playing={false}
                                width={'auto'}
                                config={{
                                    youtube: {
                                        playerVars: {
                                            origin: window.location.origin
                                        }
                                    }
                                }}
                                style={{ borderRadius: '10px' }}
                            />
                        </>

                }
            </div>
        </>
    );
}
